var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWellboat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 35,
    viewBox: "0 0 80 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2672 5.44678H30.0132V5.70093H30.2672V5.44678Z",
    fill: "#7F959D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.191 11.967H29.2166L25.0474 3.68559e-05L26.8328 9.84091L26.191 11.967Z",
    fill: "#C2CDD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6479 7.99414H29.9481L27.2878 8.94141L25.6479 7.99414Z",
    fill: "#C2C3C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1245 4.21683H28.1313L26.3024 4.79443L25.1245 4.21683Z",
    fill: "#C2C3C1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2324 5.98353H31.3803L26.8723 6.83838L25.2324 5.98353Z",
    fill: "#C2C3C1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3803 5.86882H25.2324V5.98389H31.3803V5.86882Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0362 7.87932H25.6479V7.99438H30.0362V7.87932Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1313 4.10174H25.1245V4.2168H28.1313V4.10174Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3825 5.66678H29.8975V5.8689H30.3825V5.66678Z",
    fill: "#C2C3C1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9198 5.40662H29.3608C29.3259 5.40662 29.2974 5.43518 29.2974 5.4702C29.2974 5.50513 29.3259 5.53369 29.3608 5.53369H30.9198C30.9549 5.53369 30.9834 5.50513 30.9834 5.4702C30.9834 5.43518 30.9549 5.40662 30.9198 5.40662Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.64 2.23355L27.5996 4.10156H27.6804L27.64 2.23355Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.109 23.5818H43.0166V20.7784H43.109V23.5818Z",
    fill: "#647980"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9584 20.8489H43.0166V20.7565H46.9584V20.8489Z",
    fill: "#647980"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9584 21.4639H43.0166V21.3714H46.9584V21.4639Z",
    fill: "#647980"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9584 22.0791H43.0166V21.9867H46.9584V22.0791Z",
    fill: "#647980"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9584 22.6943H43.0166V22.6019H46.9584V22.6943Z",
    fill: "#647980"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9584 23.3093H43.0166V23.2169H46.9584V23.3093Z",
    fill: "#647980"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8785 23.5818H43.7861V20.7784H43.8785V23.5818Z",
    fill: "#647980"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6485 23.5818H44.5562V20.7784H44.6485V23.5818Z",
    fill: "#647980"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4185 23.5818H45.3262V20.7784H45.4185V23.5818Z",
    fill: "#647980"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1881 23.5818H46.0957V20.7784H46.1881V23.5818Z",
    fill: "#647980"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9581 23.5818H46.8657V20.7784H46.9581V23.5818Z",
    fill: "#647980"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M47.443 23.5818H47.3506V20.7784H47.443V23.5818Z",
    fill: "#647980"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2924 20.8489H47.3506V20.7565H51.2924V20.8489Z",
    fill: "#647980"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2924 21.4639H47.3506V21.3714H51.2924V21.4639Z",
    fill: "#647980"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2924 22.0791H47.3506V21.9867H51.2924V22.0791Z",
    fill: "#647980"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2924 22.6943H47.3506V22.6019H51.2924V22.6943Z",
    fill: "#647980"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2924 23.3093H47.3506V23.2169H51.2924V23.3093Z",
    fill: "#647980"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M48.213 23.5818H48.1206V20.7784H48.213V23.5818Z",
    fill: "#647980"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M48.983 23.5818H48.8906V20.7784H48.983V23.5818Z",
    fill: "#647980"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M49.753 23.5818H49.6606V20.7784H49.753V23.5818Z",
    fill: "#647980"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5226 23.5818H50.4302V20.7784H50.5226V23.5818Z",
    fill: "#647980"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2926 23.5818H51.2002V20.7784H51.2926V23.5818Z",
    fill: "#647980"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0001 23.3479H41.9077V20.5445H42.0001V23.3479Z",
    fill: "#7F959D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8495 20.615H41.9077V20.5226H45.8495V20.615Z",
    fill: "#7F959D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8495 21.23H41.9077V21.1376H45.8495V21.23Z",
    fill: "#7F959D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8495 21.8452H41.9077V21.7528H45.8495V21.8452Z",
    fill: "#7F959D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8495 22.4604H41.9077V22.368H45.8495V22.4604Z",
    fill: "#7F959D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8495 23.0757H41.9077V22.9833H45.8495V23.0757Z",
    fill: "#7F959D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7701 23.3479H42.6777V20.5445H42.7701V23.3479Z",
    fill: "#7F959D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5396 23.3479H43.4473V20.5445H43.5396V23.3479Z",
    fill: "#7F959D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3097 23.3479H44.2173V20.5445H44.3097V23.3479Z",
    fill: "#7F959D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0792 23.3479H44.9868V20.5445H45.0792V23.3479Z",
    fill: "#7F959D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8492 23.3479H45.7568V20.5445H45.8492V23.3479Z",
    fill: "#7F959D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6978 21.6025H55.719V22.324H48.6978V21.6025",
    fill: "#33568A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2423 23.3479H46.1499V20.5445H46.2423V23.3479Z",
    fill: "#7F959D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0917 20.615H46.1499V20.5226H50.0917V20.615Z",
    fill: "#7F959D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0917 21.23H46.1499V21.1376H50.0917V21.23Z",
    fill: "#7F959D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0917 21.8452H46.1499V21.7528H50.0917V21.8452Z",
    fill: "#7F959D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0917 22.4604H46.1499V22.368H50.0917V22.4604Z",
    fill: "#7F959D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0917 23.0757H46.1499V22.9833H50.0917V23.0757Z",
    fill: "#7F959D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0123 23.3479H46.9199V20.5445H47.0123V23.3479Z",
    fill: "#7F959D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7818 23.3479H47.6895V20.5445H47.7818V23.3479Z",
    fill: "#7F959D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5519 23.3479H48.4595V20.5445H48.5519V23.3479Z",
    fill: "#7F959D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3214 23.3479H49.229V20.5445H49.3214V23.3479Z",
    fill: "#7F959D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0914 23.3479H49.999V20.5445H50.0914V23.3479Z",
    fill: "#7F959D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M50.791 14.6541H51.5975V14.5616H50.791V14.6541Z",
    fill: "#33568A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M51.204 16.3315C50.9927 16.3315 50.8208 16.1597 50.8208 15.9483C50.8208 15.7688 50.9448 15.6177 51.1116 15.5763V15.35C51.1116 15.299 51.1529 15.2576 51.204 15.2576C51.2551 15.2576 51.2964 15.299 51.2964 15.35V15.7499H51.204C51.0945 15.7499 51.0056 15.8389 51.0056 15.9483C51.0056 16.0577 51.0945 16.1467 51.204 16.1467C51.3134 16.1467 51.4024 16.0577 51.4024 15.9483C51.4024 15.8973 51.4437 15.8559 51.4947 15.8559C51.5458 15.8559 51.5871 15.8973 51.5871 15.9483C51.5871 16.1597 51.4153 16.3315 51.204 16.3315",
    fill: "#696D6F"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5253 8.55159L56.4801 6.4006L51.1455 10.8481L57.4064 22.3494L57.4876 22.3052L51.2629 10.8705L56.4988 6.50531L62.4944 8.63865L62.5253 8.55159Z",
    fill: "#33568A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1113 15.0027H51.2961V10.8594H51.1113V15.0027Z",
    fill: "#33568A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M56.21 6.67603L62.7778 17.6995L62.8572 17.6521L56.2893 6.62871",
    fill: "#33568A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0381 11.2108L62.3562 17.7898L62.4027 17.7099L51.0845 11.1309",
    fill: "#33568A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2721 18.0405L56.3701 6.44808L56.6083 6.30613L63.5103 17.8987L63.2721 18.0405",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9019 17.8223L51.2544 11.018L51.3943 10.7786L63.0417 17.5829L62.9019 17.8223Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7812 8.76929L63.5117 6.1662L63.6946 6.14078L64.0565 8.74378L63.7812 8.76929Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9555 9.01081H62.9717L63.8955 18.4111H65.1565L63.9555 9.01081",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4268 9.01074H62.5098V8.59487H64.4268V9.01074Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M62.71 8.59497H62.5098V7.40899H62.71V8.59497Z",
    fill: "#C2C3C1"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1838 18.4373H61.1582L61.4354 17.5015H64.1838V18.4373Z",
    fill: "#7F959D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5827 18.0271H61.522V17.6054H61.5827V18.0271Z",
    fill: "#6A7478"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7154 18.0271H61.6548V17.6054H61.7154V18.0271Z",
    fill: "#6A7478"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8483 18.0271H61.7876V17.6054H61.8483V18.0271Z",
    fill: "#6A7478"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M61.981 18.0271H61.9204V17.6054H61.981V18.0271Z",
    fill: "#6A7478"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1139 18.0271H62.0532V17.6054H62.1139V18.0271Z",
    fill: "#6A7478"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2466 18.0271H62.186V17.6054H62.2466V18.0271Z",
    fill: "#6A7478"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3795 18.0271H62.3188V17.6054H62.3795V18.0271Z",
    fill: "#6A7478"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5098 7.57446V7.40894H64.4268V7.57446H62.5098Z",
    fill: "#C2C3C1"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5098 8.10986V7.95581H64.4268V8.10986H62.5098Z",
    fill: "#C2C3C1"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4268 8.59497H64.2266V7.40899H64.4268V8.59497Z",
    fill: "#C2C3C1"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M63.545 8.59497H63.3911V7.40899H63.545V8.59497Z",
    fill: "#C2C3C1"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1.84473 22.0363C1.84473 21.7891 1.64435 21.5886 1.39722 21.5886C1.15009 21.5886 0.949707 21.7891 0.949707 22.0363C0.949707 22.2835 1.15009 22.4839 1.39722 22.4839C1.64435 22.4839 1.84473 22.2835 1.84473 22.0363Z",
    fill: "#33568A"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7902 20.3319H10.2773V21.6951H12.2521L11.7902 20.3319Z",
    fill: "#9FA2A1"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0095 20.4993H10.3701V20.4184H11.0095V20.4993Z",
    fill: "#33568A"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0095 20.6667H10.3701V20.5859H11.0095V20.6667Z",
    fill: "#33568A"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0095 20.8342H10.3701V20.7534H11.0095V20.8342Z",
    fill: "#33568A"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0095 21.002H10.3701V20.9211H11.0095V21.002Z",
    fill: "#33568A"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0095 21.1694H10.3701V21.0886H11.0095V21.1694Z",
    fill: "#33568A"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9008 22.0363C2.9008 21.7891 2.7005 21.5886 2.45328 21.5886C2.20615 21.5886 2.00586 21.7891 2.00586 22.0363C2.00586 22.2835 2.20615 22.4839 2.45328 22.4839C2.7005 22.4839 2.9008 22.2835 2.9008 22.0363Z",
    fill: "#33568A"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09277 15.4871V17.1162C2.09277 17.1354 2.10829 17.1509 2.12742 17.1509C2.14654 17.1509 2.16206 17.1354 2.16206 17.1162V15.4871C2.16206 15.468 2.14654 15.4524 2.12742 15.4524C2.10829 15.4524 2.09277 15.468 2.09277 15.4871Z",
    fill: "#3E4042"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M2.46143 15.4871V17.1162C2.46143 17.1354 2.47695 17.1509 2.49607 17.1509C2.51519 17.1509 2.53071 17.1354 2.53071 17.1162V15.4871C2.53071 15.468 2.51519 15.4524 2.49607 15.4524C2.47695 15.4524 2.46143 15.468 2.46143 15.4871Z",
    fill: "#3E4042"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07887 20.5649C8.07887 20.3051 7.97356 20.0698 7.80338 19.8995C7.63312 19.7292 7.3979 19.6239 7.13812 19.6239C6.61854 19.6239 6.19727 20.0452 6.19727 20.5649C6.19727 21.0848 6.61854 21.5061 7.13812 21.5061C7.65769 21.5061 8.07887 21.0848 8.07887 20.5649",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46733 16.6345L4.78174 17.0591L6.2235 20.781L7.80375 19.8995L5.46733 16.6345Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71735 16.7652C5.71735 16.4104 5.42985 16.1229 5.07518 16.1229C4.72061 16.1229 4.43311 16.4104 4.43311 16.7652C4.43311 17.1199 4.72061 17.4075 5.07518 17.4075C5.42985 17.4075 5.71735 17.1199 5.71735 16.7652Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37267 15.202L5.17878 16.4571L4.91669 17.0435L2.24121 15.527L2.37267 15.202",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M2.61015 15.3693C2.61015 15.2006 2.47333 15.0637 2.30454 15.0637C2.13575 15.0637 1.99902 15.2006 1.99902 15.3693C1.99902 15.5382 2.13575 15.675 2.30454 15.675C2.47333 15.675 2.61015 15.5382 2.61015 15.3693Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56934 17.4592H2.06325L1.93262 17.1163H2.69988L2.56934 17.4592Z",
    fill: "#33568A"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47136 17.5122H2.16113V17.406H2.47136V17.5122Z",
    fill: "#33568A"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27051 17.6917H2.36289V17.512H2.27051V17.6917Z",
    fill: "#696D6F"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31661 17.656C2.19189 17.656 2.09091 17.7571 2.09082 17.8819C2.09091 18.0067 2.19189 18.1077 2.31661 18.1077C2.44133 18.1077 2.54231 18.0067 2.5424 17.8819C2.5424 17.8564 2.52171 17.8357 2.49621 17.8357C2.47062 17.8357 2.45001 17.8564 2.45001 17.8819C2.44983 17.9555 2.39024 18.0152 2.31661 18.0153C2.24298 18.0152 2.18339 17.9555 2.18321 17.8819C2.18339 17.8082 2.24298 17.7486 2.31661 17.7484C2.34211 17.7484 2.3628 17.7277 2.3628 17.7022C2.3628 17.6767 2.34211 17.656 2.31661 17.656Z",
    fill: "#696D6F"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48321 16.7654C5.48321 16.5399 5.30048 16.3571 5.07506 16.3571C4.84973 16.3571 4.66699 16.5399 4.66699 16.7654C4.66699 16.9909 4.84973 17.1736 5.07506 17.1736C5.30048 17.1736 5.48321 16.9909 5.48321 16.7654Z",
    fill: "#33568A"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29997 16.7654C5.29997 16.6414 5.19946 16.5408 5.07548 16.5408C4.9515 16.5408 4.85107 16.6414 4.85107 16.7654C4.85107 16.8894 4.9515 16.99 5.07548 16.99C5.19946 16.99 5.29997 16.8894 5.29997 16.7654Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4713 15.3695C2.4713 15.2773 2.39656 15.2027 2.30445 15.2027C2.21234 15.2027 2.1377 15.2773 2.1377 15.3695C2.1377 15.4616 2.21234 15.5364 2.30445 15.5364C2.39656 15.5364 2.4713 15.4616 2.4713 15.3695Z",
    fill: "#33568A"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M2.38586 15.3693C2.38586 15.3246 2.34955 15.2882 2.30475 15.2882C2.25994 15.2882 2.22363 15.3246 2.22363 15.3693C2.22363 15.4141 2.25994 15.4504 2.30475 15.4504C2.34955 15.4504 2.38586 15.4141 2.38586 15.3693Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68735 20.565C7.68735 20.2617 7.44161 20.0159 7.1384 20.0159C6.83519 20.0159 6.58936 20.2617 6.58936 20.565C6.58936 20.8683 6.83519 21.1143 7.1384 21.1143C7.44161 21.1143 7.68735 20.8683 7.68735 20.565",
    fill: "#33568A"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45835 20.5649C7.45835 20.3879 7.31488 20.2443 7.13787 20.2443C6.96086 20.2443 6.81738 20.3879 6.81738 20.5649C6.81738 20.742 6.96086 20.8855 7.13787 20.8855C7.31488 20.8855 7.45835 20.742 7.45835 20.5649Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20968 21.1512H6.06689V21.7053H8.20968V21.1512Z",
    fill: "#9FA2A1"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60159 21.428H5.6958V22.1702H8.60159V21.428",
    fill: "#959796"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0297 17.0857H69.9614V17.6182H73.0297V17.0857Z",
    fill: "#A2AFB0"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3147 21.6951H6.52441V22.1465H13.3147V21.6951Z",
    fill: "#959796"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2283 18.9463H78.479V17.6522H78.9169L79.2283 18.9463Z",
    fill: "#152C39"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M75.639 18.5279C75.639 18.184 75.3609 17.9051 75.0172 17.9051C74.6726 17.9051 74.3945 18.184 74.3945 18.5279C74.3945 18.8718 74.6726 19.1506 75.0172 19.1506C75.3609 19.1506 75.639 18.8718 75.639 18.5279Z",
    fill: "#7F959D"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M77.176 18.5279C77.176 18.184 76.897 17.9051 76.5533 17.9051C76.2097 17.9051 75.9307 18.184 75.9307 18.5279C75.9307 18.8718 76.2097 19.1506 76.5533 19.1506C76.897 19.1506 77.176 18.8718 77.176 18.5279Z",
    fill: "#7F959D"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8598 18.4355H67.5273V17.6182H73.3923L73.8598 18.0723V18.4355",
    fill: "#7F959D"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M79.977 18.4111C79.977 18.4111 79.977 21.0059 78.473 23.393C75.3698 28.3161 70.0471 34.6998 64.933 34.6998L3.52717 34.7922C3.52717 34.7922 1.09134 28.6967 0.321406 25.5102C0.0577388 24.4188 0 22.1484 0 22.1484L14.9356 22.0868V19.6566H40.795L41.8112 22.2998L57.4468 22.3271C57.4468 22.3271 59.0726 21.7711 59.7169 20.8171C60.1144 20.2283 60.0546 18.4577 60.0546 18.4577L79.977 18.4111",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M79.977 18.4111C79.977 18.4111 79.977 21.0059 78.473 23.393C75.3698 28.3161 70.0471 34.6998 64.933 34.6998L3.52717 34.7922C3.52717 34.7922 1.18567 28.9564 0.321406 25.5102C0.14957 24.825 0 22.7029 0 22.7029L5.26595 21.0086L55.5793 21.0333C55.5793 21.0333 57.1126 21.0318 57.7569 20.0778C58.1544 19.489 58.187 18.4577 58.187 18.4577L79.977 18.4111Z",
    fill: "#A2B4C3"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1699 15.7564H40.795V19.6567H19.1699V15.7564Z",
    fill: "#C2CDD6"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M42.458 11.967H24.9902V15.7561H40.795L42.458 11.967Z",
    fill: "#C2CDD6"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M41.434 14.3005H28.709V12.4522H42.2453L41.434 14.3005Z",
    fill: "#515455"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3486 14.0928H28.8936V12.6372H30.3486V14.0928Z",
    fill: "#80BFE1"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0464 14.0928H30.5913V12.6372H32.0464V14.0928Z",
    fill: "#80BFE1"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7436 14.0928H32.2886V12.6372H33.7436V14.0928Z",
    fill: "#80BFE1"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4414 14.0928H33.9863V12.6372H35.4414V14.0928Z",
    fill: "#80BFE1"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1387 14.0928H35.6836V12.6372H37.1387V14.0928Z",
    fill: "#80BFE1"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8364 14.0928H37.3813V12.6372H38.8364V14.0928Z",
    fill: "#80BFE1"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5342 14.0928H39.0791V12.6372H40.5342V14.0928Z",
    fill: "#80BFE1"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2441 17.0964H33.2009C33.0993 17.0964 33.0161 17.1796 33.0161 17.2813V19.386C33.0161 19.4876 33.0993 19.5708 33.2009 19.5708H34.2441C34.3457 19.5708 34.4289 19.4876 34.4289 19.386V17.2813C34.4289 17.1796 34.3457 17.0964 34.2441 17.0964Z",
    fill: "#2C3A44"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2313 17.0964H36.1882C36.0866 17.0964 36.0034 17.1796 36.0034 17.2813V19.386C36.0034 19.4876 36.0866 19.5708 36.1882 19.5708H37.2313C37.3329 19.5708 37.4161 19.4876 37.4161 19.386V17.2813C37.4161 17.1796 37.3329 17.0964 37.2313 17.0964Z",
    fill: "#2C3A44"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5249 14.0928H40.7764V12.6372H42.1637L41.5249 14.0928Z",
    fill: "#80BFE1"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2652 15.4942H18.6309V15.7561H41.2652V15.4942Z",
    fill: "#C2C3C1"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6471 11.8363H24.7861V12.0981H42.6471V11.8363Z",
    fill: "#C2C3C1"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M40.795 19.4605H14.9434V19.6807H40.795V19.4605Z",
    fill: "#C2C3C1"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1338 18.6672H29.9328C29.8312 18.6672 29.748 18.5841 29.748 18.4824V17.281C29.748 17.1793 29.8312 17.0962 29.9328 17.0962H31.1338C31.2355 17.0962 31.3186 17.1793 31.3186 17.281V18.4824C31.3186 18.5841 31.2355 18.6672 31.1338 18.6672Z",
    fill: "#2C3A44"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7095 22.2727H37.5085C37.4069 22.2727 37.3237 22.1896 37.3237 22.0879V20.8865C37.3237 20.7849 37.4069 20.7016 37.5085 20.7016H38.7095C38.8111 20.7016 38.8943 20.7849 38.8943 20.8865V22.0879C38.8943 22.1896 38.8111 22.2727 38.7095 22.2727Z",
    fill: "#2C3A44"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8755 22.2727H33.6745C33.5729 22.2727 33.4897 22.1896 33.4897 22.0879V20.8865C33.4897 20.7849 33.5729 20.7016 33.6745 20.7016H34.8755C34.9771 20.7016 35.0603 20.7849 35.0603 20.8865V22.0879C35.0603 22.1896 34.9771 22.2727 34.8755 22.2727Z",
    fill: "#2C3A44"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M26.376 22.2727H25.175C25.0734 22.2727 24.9902 22.1896 24.9902 22.0879V20.8865C24.9902 20.7849 25.0734 20.7016 25.175 20.7016H26.376C26.4776 20.7016 26.5608 20.7849 26.5608 20.8865V22.0879C26.5608 22.1896 26.4776 22.2727 26.376 22.2727Z",
    fill: "#2C3A44"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M18.708 22.2727H17.507C17.4054 22.2727 17.3223 22.1896 17.3223 22.0879V20.8865C17.3223 20.7849 17.4054 20.7016 17.507 20.7016H18.708C18.8097 20.7016 18.8928 20.7849 18.8928 20.8865V22.0879C18.8928 22.1896 18.8097 22.2727 18.708 22.2727Z",
    fill: "#2C3A44"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9239 18.6672H26.7229C26.6212 18.6672 26.5381 18.5841 26.5381 18.4824V17.281C26.5381 17.1793 26.6212 17.0962 26.7229 17.0962H27.9239C28.0255 17.0962 28.1086 17.1793 28.1086 17.281V18.4824C28.1086 18.5841 28.0255 18.6672 27.9239 18.6672Z",
    fill: "#2C3A44"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5723 18.6672H20.3713C20.2697 18.6672 20.1865 18.5841 20.1865 18.4824V17.281C20.1865 17.1793 20.2697 17.0962 20.3713 17.0962H21.5723C21.6739 17.0962 21.7571 17.1793 21.7571 17.281V18.4824C21.7571 18.5841 21.6739 18.6672 21.5723 18.6672Z",
    fill: "#2C3A44"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8803 18.411H40.7417V19.6807H40.8803V18.411Z",
    fill: "#C2C3C1"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2636 18.411H39.125V19.6807H39.2636V18.411Z",
    fill: "#C2C3C1"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6469 18.411H37.5083V19.6807H37.6469V18.411Z",
    fill: "#C2C3C1"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0302 18.411H35.8916V19.6807H36.0302V18.411Z",
    fill: "#C2C3C1"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4135 18.411H34.2749V19.6807H34.4135V18.411Z",
    fill: "#C2C3C1"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7968 18.411H32.6582V19.6807H32.7968V18.411Z",
    fill: "#C2C3C1"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1796 18.411H31.041V19.6807H31.1796V18.411Z",
    fill: "#C2C3C1"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5634 18.411H29.4248V19.6807H29.5634V18.411Z",
    fill: "#C2C3C1"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9462 18.411H27.8076V19.6807H27.9462V18.411Z",
    fill: "#C2C3C1"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3295 18.411H26.1909V19.6807H26.3295V18.411Z",
    fill: "#C2C3C1"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7133 18.411H24.5747V19.6807H24.7133V18.411Z",
    fill: "#C2C3C1"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0961 18.411H22.9575V19.6807H23.0961V18.411Z",
    fill: "#C2C3C1"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4799 18.411H21.3413V19.6807H21.4799V18.411Z",
    fill: "#C2C3C1"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8632 18.411H19.7246V19.6807H19.8632V18.411Z",
    fill: "#C2C3C1"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M18.246 18.411H18.1074V19.6807H18.246V18.411Z",
    fill: "#C2C3C1"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6298 18.411H16.4912V19.6807H16.6298V18.411Z",
    fill: "#C2C3C1"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0583 18.411H14.9199V19.6807H15.0583V18.411Z",
    fill: "#C2C3C1"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7767 18.5596H14.9434V18.4111H40.7767V18.5596Z",
    fill: "#C2C3C1"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7767 19.0461H14.9434V18.8978H40.7767V19.0461Z",
    fill: "#C2C3C1"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M14.954 21.9263H0V22.1465H14.954V21.9263Z",
    fill: "#C2C3C1"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M0.154005 20.8769H0V22.1465H0.154005V20.8769Z",
    fill: "#C2C3C1"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93233 20.8769H1.77832V22.1465H1.93233V20.8769Z",
    fill: "#C2C3C1"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71065 20.8769H3.55664V22.1465H3.71065V20.8769Z",
    fill: "#C2C3C1"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48897 20.8769H5.33496V22.1465H5.48897V20.8769Z",
    fill: "#C2C3C1"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26778 20.8769H7.11377V22.1465H7.26778V20.8769Z",
    fill: "#C2C3C1"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04561 20.8769H8.8916V22.1465H9.04561V20.8769Z",
    fill: "#C2C3C1"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8249 20.8769H10.6709V22.1465H10.8249V20.8769Z",
    fill: "#C2C3C1"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6027 20.8769H12.4487V22.1465H12.6027V20.8769Z",
    fill: "#C2C3C1"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3815 20.8769H14.2275V22.1465H14.3815V20.8769Z",
    fill: "#C2C3C1"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9434 21.0249H0V20.8766H14.9434V21.0249Z",
    fill: "#C2C3C1"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9434 21.5117H0V21.3633H14.9434V21.5117Z",
    fill: "#C2C3C1"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8754 18.2388H60.0615V18.459H79.8754V18.2388Z",
    fill: "#C2C3C1"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9999 17.1894H79.8613V18.459H79.9999V17.1894Z",
    fill: "#C2C3C1"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3437 17.1894H78.2051V18.459H78.3437V17.1894Z",
    fill: "#C2C3C1"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M76.727 17.1894H76.5884V18.459H76.727V17.1894Z",
    fill: "#C2C3C1"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0941 17.1894H74.9556V18.459H75.0941V17.1894Z",
    fill: "#C2C3C1"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4613 17.1894H73.3228V18.459H73.4613V17.1894Z",
    fill: "#C2C3C1"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M71.828 17.1894H71.6895V18.459H71.828V17.1894Z",
    fill: "#C2C3C1"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1947 17.1894H70.0562V18.459H70.1947V17.1894Z",
    fill: "#C2C3C1"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5614 17.1894H68.4229V18.459H68.5614V17.1894Z",
    fill: "#C2C3C1"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9281 17.1894H66.7896V18.459H66.9281V17.1894Z",
    fill: "#C2C3C1"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2948 17.1894H65.1562V18.459H65.2948V17.1894Z",
    fill: "#C2C3C1"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M63.662 17.1894H63.5234V18.459H63.662V17.1894Z",
    fill: "#C2C3C1"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9364 17.1894H61.7979V18.459H61.9364V17.1894Z",
    fill: "#C2C3C1"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2001 17.1894H60.0615V18.459H60.2001V17.1894Z",
    fill: "#C2C3C1"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8615 17.3379H60.0615V17.1895H79.8615V17.3379Z",
    fill: "#C2C3C1"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8615 17.8242H60.0615V17.6759H79.8615V17.8242Z",
    fill: "#C2C3C1"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41147 26.0924C8.41147 25.7565 8.13921 25.4841 7.80339 25.4841C7.46748 25.4841 7.19531 25.7565 7.19531 26.0924C7.19531 26.4283 7.46748 26.7007 7.80339 26.7007C8.13921 26.7007 8.41147 26.4283 8.41147 26.0924Z",
    fill: "#7AB9E3"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2787 26.0924C11.2787 25.7565 11.0064 25.4841 10.6706 25.4841C10.3348 25.4841 10.0625 25.7565 10.0625 26.0924C10.0625 26.4283 10.3348 26.7007 10.6706 26.7007C11.0064 26.7007 11.2787 26.4283 11.2787 26.0924Z",
    fill: "#7AB9E3"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7567 26.0924C21.7567 25.7565 21.4844 25.4841 21.1486 25.4841C20.8128 25.4841 20.5405 25.7565 20.5405 26.0924C20.5405 26.4283 20.8128 26.7007 21.1486 26.7007C21.4844 26.7007 21.7567 26.4283 21.7567 26.0924Z",
    fill: "#7AB9E3"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2347 26.0924C32.2347 25.7565 31.9625 25.4841 31.6266 25.4841C31.2908 25.4841 31.0186 25.7565 31.0186 26.0924C31.0186 26.4283 31.2908 26.7007 31.6266 26.7007C31.9625 26.7007 32.2347 26.4283 32.2347 26.0924Z",
    fill: "#7AB9E3"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9403 26.0924C59.9403 25.7565 59.6681 25.4841 59.3322 25.4841C58.9964 25.4841 58.7241 25.7565 58.7241 26.0924C58.7241 26.4283 58.9964 26.7007 59.3322 26.7007C59.6681 26.7007 59.9403 26.4283 59.9403 26.0924Z",
    fill: "#7AB9E3"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5287 26.0924C62.5287 25.7565 62.2564 25.4841 61.9206 25.4841C61.5848 25.4841 61.3125 25.7565 61.3125 26.0924C61.3125 26.4283 61.5848 26.7007 61.9206 26.7007C62.2564 26.7007 62.5287 26.4283 62.5287 26.0924Z",
    fill: "#7AB9E3"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8145 21.3418C76.8145 20.7653 76.347 20.2979 75.7705 20.2979C75.194 20.2979 74.7266 20.7653 74.7266 21.3418C74.7266 21.9183 75.194 22.3857 75.7705 22.3857C76.347 22.3857 76.8145 21.9183 76.8145 21.3418",
    fill: "#959796"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0503 22.0918L74.252 21.2568L74.4007 20.758L77.1991 21.5929L77.0503 22.0918Z",
    fill: "#33568A"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9541 21.4661L74.252 21.2566L74.567 19.754L75.0252 19.8906L74.9541 21.4661",
    fill: "#33568A"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0505 22.0918L76.4712 21.9188L77.1521 20.5255L77.6103 20.6622L77.0505 22.0918Z",
    fill: "#33568A"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1557 20.5943L75.8204 20.4941L75.3853 21.5063L75.9654 21.6794L76.1557 20.5943Z",
    fill: "#33568A"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5162 10.8592C51.5162 10.687 51.3766 10.5473 51.2044 10.5473C51.0322 10.5473 50.8926 10.687 50.8926 10.8592C50.8926 11.0315 51.0322 11.1711 51.2044 11.1711C51.3766 11.1711 51.5162 11.0315 51.5162 10.8592Z",
    fill: "#33568A"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8013 6.45299C56.8013 6.28072 56.6617 6.14108 56.4895 6.14108C56.3173 6.14108 56.1777 6.28072 56.1777 6.45299C56.1777 6.62525 56.3173 6.76489 56.4895 6.76489C56.6617 6.76489 56.8013 6.62525 56.8013 6.45299Z",
    fill: "#33568A"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3464 10.859C51.3464 10.7803 51.2826 10.7165 51.204 10.7165C51.1253 10.7165 51.0615 10.7803 51.0615 10.859C51.0615 10.9376 51.1253 11.0015 51.204 11.0015C51.2826 11.0015 51.3464 10.9376 51.3464 10.859Z",
    fill: "#C2C3C1"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6315 6.45304C56.6315 6.37431 56.5678 6.31054 56.489 6.31054C56.4104 6.31054 56.3467 6.37431 56.3467 6.45304C56.3467 6.53169 56.4104 6.59546 56.489 6.59546C56.5678 6.59546 56.6315 6.53169 56.6315 6.45304Z",
    fill: "#C2C3C1"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6139 15.2642H50.7945L50.583 14.7088H51.8254L51.6139 15.2642",
    fill: "#33568A"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4553 15.3499H50.9531V15.1781H51.4553V15.3499Z",
    fill: "#33568A"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8688 14.7085V14.5525H50.7129V14.7085H50.8688Z",
    fill: "#696D6F"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6754 14.7085V14.5525H51.5195V14.7085H51.6754Z",
    fill: "#696D6F"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0649 22.2109H55.5576V21.7181H55.0649V22.2109Z",
    fill: "#7F959D"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3955 22.2109H54.8882V21.7181H54.3955V22.2109",
    fill: "#7F959D"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7251 22.2109H54.2178V21.7181H53.7251V22.2109Z",
    fill: "#7F959D"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2884 5.98364L32.248 11.8362H32.3289L32.2884 5.98364Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9715 3.1676L20.9312 15.4944H21.012L20.9715 3.1676Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2972 7.87909L33.2568 11.8362H33.3377L33.2972 7.87909Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9081 7.87909L36.8677 11.8362H36.9485L36.9081 7.87909Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8799 10.3046H36.03V11.8362H35.8799V10.3046Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1177 10.3046H35.2678V11.8362H35.1177V10.3046Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4179 10.5386H35.1177V10.2382H35.4179V10.5386Z",
    fill: "#7F959D"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4179 11.0295H35.1177V10.7292H35.4179V11.0295Z",
    fill: "#7F959D"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0846 10.3046C36.0846 10.2328 36.0264 10.1747 35.9546 10.1747C35.8829 10.1747 35.8247 10.2328 35.8247 10.3046C35.8247 10.3764 35.8829 10.4346 35.9546 10.4346C36.0264 10.4346 36.0846 10.3764 36.0846 10.3046Z",
    fill: "#7F959D"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0846 10.5991C36.0846 10.5273 36.0264 10.469 35.9546 10.469C35.8829 10.469 35.8247 10.5273 35.8247 10.5991C35.8247 10.6708 35.8829 10.729 35.9546 10.729C36.0264 10.729 36.0846 10.6708 36.0846 10.5991Z",
    fill: "#7F959D"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0846 10.8937C36.0846 10.8219 36.0264 10.7638 35.9546 10.7638C35.8829 10.7638 35.8247 10.8219 35.8247 10.8937C35.8247 10.9656 35.8829 11.0237 35.9546 11.0237C36.0264 11.0237 36.0846 10.9656 36.0846 10.8937Z",
    fill: "#7F959D"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8985 11.6138H38.2817V11.8362H39.8985V11.6138Z",
    fill: "#7F959D"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8983 10.8283C39.8983 10.4584 39.5985 10.1585 39.2287 10.1585C38.8589 10.1585 38.5591 10.4584 38.5591 10.8283C38.5591 11.1982 38.8589 11.498 39.2287 11.498C39.5985 11.498 39.8983 11.1982 39.8983 10.8283Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6213 11.3734H38.8364V11.614H39.6213V11.3734Z",
    fill: "#C2C3C1"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2597 15.4944H20.6592V15.2182H21.2597V15.4944Z",
    fill: "#7F959D"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1845 15.4944H22.584V15.2182H23.1845V15.4944Z",
    fill: "#7F959D"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0776 15.4944H23.4771V15.2182H24.0776V15.4944Z",
    fill: "#7F959D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellboat);
export default __webpack_public_path__ + "static/media/wellboat.19e528e66ede14c071aafcf815ebbd69.svg";
export { ForwardRef as ReactComponent };